import React ,{Component} from 'react';
import { Navigate } from 'react-router-dom';
import ROUTES from './../../constants/routes';
//import Config from './../../constants/config';
import FormValidator from '../login/FormValidator';
import alert from './../../images/alert.png';
import spinner from './../../Spinnerimage.gif';
import {HttpStatusCode, ResultCodes, Messages} from './../../constants/utilities';
import AxiosDataService from '../../services/AxiosDataService';
import {connect} from 'react-redux';
import {OnLinkingSuccess,OnValidateCodePageLoad, OnValidateCodeCancel, OnValidateGetNewCode, OnValidateInvalidCode, OnValidCodeLastAttempt, OnValidCodeExpired, OnValidateCodeContinue} from './../../components/SiteCat/SiteCat';
import {onUserCancel} from './../../constants/merchantData';

 class ValidateCode extends Component{
   constructor(props) {
     super(props)

     this.validator = new FormValidator([
       {
         field: 'identificationCode',
         method: 'isEmpty',
         validWhen: false,
         message: Messages.ENTER_VALID_OOB_CODE
       }

     ]);

     this.state = {
       maskedValue: "",
       identificationCode: "",
       oobCancel: false,
       pageName: "",
       doRedirect: false,
       locationhref: "",
       validation: this.validator.valid(),
       showError: false,
       errMessage: "",
       isLoaded: false,
       linkId: "",
       isSubmit: false,
       merchantName:""

     }
   }

   componentDidMount() {
    OnValidateCodePageLoad(this.state.merchantName);
    const jwtTokenData = this.props.validateposts.jwtToken.jwtToken;
    const cancelUrl = this.props.validateposts.cancelUrl;
    var linkidresponse = "";
    if(!this.props.validateposts.loginresponse){
         linkidresponse =  this.props.validateposts.linkfiresponse.linkId ;
    }else{
         linkidresponse =  this.props.validateposts.loginresponse.linkId ;
    }
    //const linkidresponse = this.props.validateposts.linkfiresponse.linkId ;
    this.setState({
      merchantName : this.props.validateposts.merchant,
      jwtTokenData,
      linkId: linkidresponse,
      last4Digit:this.props.validateposts.last4Digit,
      cancelUrl
      
    });

   const SendCodeResponse = this.props.validateposts.sendcoderesponse;


     //Assigning linkfiresponse to a variable
     const LinkFIResponse = this.props.validateposts.linkfiresponse.contactChannels;
     var filtered = LinkFIResponse.filter(LinkFIResponse => {
       return LinkFIResponse.contactIdentifier === SendCodeResponse.identifier
     });
    
     let maskedData = filtered[0].maskedValue;
     let maskedValueString = maskedData.toString();
     if (maskedValueString.includes("xxx-xxx")) {

       let subString1 = ("(").concat(maskedValueString.substring(0, 3)).concat(")").concat(" ");
       let subString2 = maskedValueString.substring(4);
       let maskedPhoneNumber = `[${subString1.concat(subString2)}]`;
     
       this.setState({ maskedValue: maskedPhoneNumber })
     }
     else {
      var emailAddrSignIndex = maskedValueString.indexOf("@");
      var emailAddrText = maskedValueString.substring(0, emailAddrSignIndex);
      var emailAddrDomainText = maskedValueString.substring(emailAddrSignIndex);
    
      if(emailAddrText.length > 10){
        var maskText = "*";
        var maskedEmailAddressText = maskText.repeat(10);
        var emailAddrStartText = emailAddrText.substring(0, 1);
        var emailAddrEndText = emailAddrText.substring(emailAddrText.length - 1);
        maskedValueString = emailAddrStartText + maskedEmailAddressText + emailAddrEndText + emailAddrDomainText;
      }
       this.setState({ maskedValue: maskedValueString })
     }
   }
   handleFormSubmit = event => {
    const identifierValue =  this.props.validateposts.sendcoderesponse.identifier;
    
    let contactmethodData;
    const textStr = ['HS','WS','SS'];
    const voiceStr  = ['HV','WV','SV'];
    const emailStr  = ['EE'];
    const getContactMethod = identifierValue.substring(0, 2);
    
    if(textStr.includes(getContactMethod)){
      contactmethodData = 'Text';
    }else if(voiceStr.includes(getContactMethod)){
      contactmethodData = 'AutoMessage';
    }else if(emailStr.includes(getContactMethod)){
      contactmethodData = 'EmailAddress';
    }else{
      contactmethodData = '';
    }
    OnValidateCodeContinue(contactmethodData, this.state.merchantName);
     const validation = this.validator.validate(this.state)
     this.setState({
       validation,
       errMessage: validation.identificationCode.message,
       isSubmit: true
     });
 

     if (validation.identificationCode.message === "" && this.state.identificationCode.length === 6 && this.state.identificationCode !== "000000") {
       this.setState({ isLoaded: true });
       let userData = {
         code: this.state.identificationCode,
         linkId: this.state.linkId,
         merchantName: this.state.merchantName,
         oobCancel: this.state.oobCancel
       }

       let randomstring = require('random-string');
       const self = this;
       const options = {
         url: "oob/validateCode",    // + Config.env,
         method: "post",
         headers: {
           "Access-Control-Allow-Origin": "*",
           //"HTTP_AUTH_TOKEN": self.state.jwtTokenData,
           'Content-Type': 'application/json',
           "REQUEST_ID": randomstring({ length: 20 })
         },
         data: JSON.stringify(userData)
        };
         AxiosDataService.fetch(options).then((responsedata) => {
           self.setState({ isLoaded: false });
           let response=responsedata.data;
           if (response.resultCode === ResultCodes.MERCHANT_REDIRECT_PAGE) {
            OnLinkingSuccess(this.state.merchantName);
             const redirecturl = response.partnerRedirectVO.href
             self.setState({
               pageName: "RedirectPage",
               doRedirect: true,
               locationhref: redirecturl
             });
           } else if (response.resultCode === ResultCodes.INVALID_OOB_CODE) {
            OnValidateInvalidCode(Messages.ENTER_VALID_OOB_CODE, this.state.merchantName);
             self.setState({
               showError: true,
               doRedirect: false,
               errMessage: Messages.ENTER_VALID_OOB_CODE
             });
           } else if (response.resultCode === ResultCodes.CID_PAGE) {
           
           
           
            self.props.dispatch({
                        type:'LOGIN_RESPONSE',
                        linkId: response.linkId,
                        response : (this.props.validateposts.loginresponse) ? (this.props.validateposts.loginresponse) : response,
                        last4Digit:(this.props.validateposts.loginresponse) ? this.props.validateposts.last4Digit : response.last4AcctNbr
                        
                    });
             self.setState({
                  pageName: "CardSecurePage",
                  doRedirect: true
                });
                

           }
           else if (response.resultCode === ResultCodes.FINAL_OOB_ATTEMPT) {
            OnValidCodeLastAttempt(Messages.INVALID_OOB_CODE, this.state.merchantName);
             self.setState({
               showError: true,
               doRedirect: false,
               errMessage: Messages.INVALID_OOB_CODE
             });
           } else if (response.resultCode === ResultCodes.EXPIRED_OOB_CODE) {
            OnValidCodeExpired(Messages.EXPIRED__OOB_CODE, this.state.merchantName);
             self.setState({
               showError: true,
               doRedirect: false,
               errMessage: Messages.EXPIRED__OOB_CODE
             });
           }
           else if (response.resultCode === ResultCodes.CARD_MEMBER_LOCKOUT) {
             self.setState({
               pageName: "TooManyOOBCodesPage",
               doRedirect: true
             });
           } else if (response.resultCode === ResultCodes.CARD_INFO_DELIVERY_FAILED) {
             self.setState({
               pageName: "TechDiff",
               doRedirect: true
             });
           }else if (response.resultCode === ResultCodes.ACCT_LINKING_PAGE) {
            
            /*self.props.dispatch({
                  type:'LOGIN_RESPONSE',
                  linkId: response.linkId,
                   response
                  });
                self.setState({ pageName: "SingleCardPage" });
                self.setState({ doRedirect: true });
            */    
                self.props.dispatch({
                  type:'LOGIN_RESPONSE',
                  linkId: response.linkId,
                   response,
                   last4Digit:self.state.last4Digit
                   
                  });
              let AccLinkingResponse = response.eligibleAccountVO;
              if (AccLinkingResponse.length === 1) {
                self.setState({ pageName: "SingleCardPage" });
                self.setState({ doRedirect: true });
              } else if (AccLinkingResponse.length > 1) {
                self.setState({ pageName: "MultiCardPage" });
                self.setState({ doRedirect: true });
              } else {
                self.setState({ pageName: "TryLinkingAgainPage" });
                self.setState({ doRedirect: true });
              }
           }
           else {
             self.setState({
               pageName: "TechDiff",
               doRedirect: true
             });
           }
         },(errorResponse) => {
           self.setState({ isLoaded: false });
           let error = errorResponse.response;
           
           if (error.status === HttpStatusCode.INTERNAL_SERVER_ERROR || error.status === HttpStatusCode.NOT_FOUND4) {
            
             self.setState({
              pageName: "TechDiff",
              doRedirect: true
            });
           } else {
            
            

             let response=error.data;
            
             if (response) {
               if (error.status === HttpStatusCode.BAD_REQUEST && response.returnCode === ResultCodes.MANDATORY_FIELD) {
                OnValidateInvalidCode(Messages.ENTER_VALID_OOB_CODE, this.state.merchantName);
                 self.setState({
                   showError: true,
                   doRedirect: false,
                   errMessage: Messages.ENTER_VALID_OOB_CODE
                 });
               } else if (response.returnCode === ResultCodes.TECH_DIFF_RA_DOWN || response.returnCode === ResultCodes.TECH_DIFF_DPL_DOWN || response.returnCode === ResultCodes.TECH_DIFF_CACHE_DOWN || response.returnCode === ResultCodes.TECH_DIFF_NO_LINK_ACTIVITY) {
                 self.setState({
                   pageName: "TechDiff",
                   doRedirect: true
                 });
               } else {
                 self.setState({
                   pageName: "TechDiff",
                   doRedirect: true
                 });
               }

             } else {
               self.setState({
                 pageName: "TechDiff",
                 doRedirect: true
               });
             }
           }

       })
     } else {
       this.setState({
         showError: true,
         errMessage: Messages.ENTER_VALID_OOB_CODE
       });
     }
   }
   handleInputChange = event => {
     event.preventDefault();
     if(event.target.value.length > 6) {
      return false;
     }
     const acceptedidentificationCode = (/^[0-9]{1,6}$/.test(+event.target.value)) ? event.target.value : this.state.identificationCode;
     const ErroMsgOnChange = (acceptedidentificationCode === "" && this.state.isSubmit) ? true : false
     const ErroDataOnChange = (acceptedidentificationCode === "" && this.state.isSubmit) ? "Please enter a valid identification code." : ""
     
     this.setState({
       [event.target.name]: acceptedidentificationCode,
       errMessage: ErroDataOnChange,
       showError: ErroMsgOnChange

     })
   }
   handleKeyPress = event => {
     if (event.key === 'Enter') {
       this.handleFormSubmit()
     }
   }
   redirectContact = event => {
    OnValidateGetNewCode(this.state.merchantName);
     this.setState({ pageName: "ContactChannels" });
     this.setState({ doRedirect: true });
   }

   handleCancel = event => {
    OnValidateCodeCancel();
     this.setState({ isLoaded: true });
     this.setState({ oobCancel: true });

     let userData = {
       code: this.state.identificationCode,
       linkId: this.state.linkId,
       merchantName: this.state.merchantName,
       oobCancel: true
     }

     let randomstring = require('random-string');
     const self = this;
     
     const options = {
       url: "oob/validateCode",
       method: "post",
       headers: {
         "Access-Control-Allow-Origin": "*",
         //"HTTP_AUTH_TOKEN": self.state.jwtTokenData,
         'Content-Type': 'application/json',
         "REQUEST_ID": randomstring({ length: 20 })
       },
       data: JSON.stringify(userData)
      };
      AxiosDataService.fetch(options).then((responsedata) => {
         self.setState({ isLoaded: false });
         let response=responsedata.data;
         if (response.resultCode === ResultCodes.ACCT_LINKING_PAGE || response.resultCode === ResultCodes.FINAL_OOB_ATTEMPT || response.resultCode === ResultCodes.CID_PAGE) {
               let AccLinkingResponse = self.props.validateposts.loginresponse.eligibleAccountVO;
               if (AccLinkingResponse.length === 1) {
                 self.setState({ pageName: "SingleCardPage" });
                 self.setState({ doRedirect: true });
               } else if (AccLinkingResponse.length > 1) {
                 self.setState({ pageName: "MultiCardPage" });
                 self.setState({ doRedirect: true });
               } else {
                 self.setState({ pageName: "TryLinkingAgainPage" });
                 self.setState({ doRedirect: true });
               }
          }else if (response.resultCode === ResultCodes.REDIRECT_TO_MERCHANT) {
            let data = {
              merchantName: this.state.merchantName,
              cancelUrlData: this.state.cancelUrl
            }
            onUserCancel(data);

         }else if (response.resultCode === ResultCodes.CARD_MEMBER_LOCKOUT) {
           self.setState({
             pageName: "TooManyOOBCodesPage",
             doRedirect: true
           });
         } else if (response.resultCode === ResultCodes.CARD_INFO_DELIVERY_FAILED) {
           self.setState({
             pageName: "TechDiff",
             doRedirect: true
           });
         }
         else {
           self.setState({ pageName: "TechDiff" });
           self.setState({ doRedirect: true });
         }
       },(errorResponse) => {
         self.setState({ isLoaded: false });
         let error = errorResponse.response;
         if (error.status === HttpStatusCode.INTERNAL_SERVER_ERROR || error.status === HttpStatusCode.NOT_FOUND) {
          
           self.setState({
             pageName: "TechDiff",
             doRedirect: true
           });
         } else {
          

           let response = error.data;
           if (response) {
             if (error.status === HttpStatusCode.BAD_REQUEST && response.returnCode === ResultCodes.MANDATORY_FIELD) {

            
              let AccLinkingResponse = self.props.validateposts.loginresponse.eligibleAccountVO;
              if (AccLinkingResponse.length === 1) {
                self.setState({ pageName: "SingleCardPage" });
                self.setState({ doRedirect: true });
              } else if (AccLinkingResponse.length > 1) {
                self.setState({ pageName: "MultiCardPage" });
                self.setState({ doRedirect: true });
              } else {
                self.setState({ pageName: "TryLinkingAgainPage" });
                self.setState({ doRedirect: true });
              }
            } else if (response.returnCode === ResultCodes.TECH_DIFF_RA_DOWN || response.returnCode === ResultCodes.TECH_DIFF_DPL_DOWN || response.returnCode === ResultCodes.TECH_DIFF_CACHE_DOWN || response.returnCode === ResultCodes.TECH_DIFF_NO_LINK_ACTIVITY) {
               self.setState({
                 pageName: "TechDiff",
                 doRedirect: true
               });
             } else {
               self.setState({
                 pageName: "TechDiff",
                 doRedirect: true
               });
             }

           } else {
             self.setState({
               pageName: "TechDiff",
               doRedirect: true
             });
           }
         }
     })
   }

   render(){
    
    if(this.state.doRedirect === true){
      //TODO: Need to change to validate OOB page for success
       if (this.state.pageName === "TooManyOOBCodesPage"){
				return <Navigate to={ROUTES.PATH.TooManyOOBCodesPage} replace />
			}else if (this.state.pageName === "LockedOutPage"){
				return <Navigate to={ROUTES.PATH.LockedOutPage} replace />
      } else if (this.state.pageName === "SingleCardPage") {
          return <Navigate to={ROUTES.PATH.SingleCardPage} replace />
        } else if (this.state.pageName === "MultiCardPage") {
          return <Navigate to={ROUTES.PATH.MultiCardPage} replace />
        }else if (this.state.pageName === "ContactChannels") {
          return <Navigate to={ROUTES.PATH.ContactChannels} replace />
        }else if (this.state.pageName === "TechDiff") {
          return <Navigate to={ROUTES.PATH.TechDiff} replace />
        }else if (this.state.pageName === "CardSecurePage") {
          return <Navigate to={ROUTES.PATH.CardSecurePage} replace />
        }else if (this.state.pageName === "RedirectPage") {
          return (
            <Navigate to={{pathname: ROUTES.PATH.RedirectPage}}
              state={{ loc: this.state.locationhref }}
              replace
            />
          );
        }
        else{
          return <Navigate to={ROUTES.PATH.TryLinkingAgainPage} replace />
        }
    }else {
      let isLoadedvalue = this.state.isLoaded;
     return(
        <React.Fragment>
          {isLoadedvalue ?
               <div className="spinner">
               <img src={spinner} alt="Spinner" />
             </div> : null
          }
          <div className="row">
            <div className="validate-blk-1 col-xs-12 col-sm-6  col-md-5 col-lg-3 col-md-offset-3 col-lg-offset-4 col-sm-offset-3">
              <div className="validate-header">
                Please Enter Your Temporary Identification Code
             </div>
           </div>
          </div>
          <div className="row">
            <div className="validate-blk-1 col-xs-12 col-sm-6  col-md-5 col-lg-3 col-md-offset-3 col-lg-offset-4 col-sm-offset-3">
              <div className="validate-section emailAddress">
              A temporary identification code has been sent to {this.state.maskedValue}
             </div>
           </div>
          </div>
          <div className="row">
            <div className="validate-blk-1 col-xs-12 col-sm-6  col-md-5 col-lg-3 col-md-offset-3 col-lg-offset-4 col-sm-offset-3">
              <div className="validate-form">
              <div>
              <input className={(!this.state.showError) ? "validate-input" : "validate-err"} type="text" name="identificationCode" placeholder="Identification Code" value={this.state.identificationCode} onChange={this.handleInputChange} onKeyPress={this.handleKeyPress} />
              <img hidden={(!this.state.showError) ? true : false} src={alert} alt="Error" />
              {/* <div className="validate-err-msg">{ this.state.showError ? validation.identificationCode.message:null }</div>  */}
              <div className="validate-err-msg">{ (this.state.showError)  ? this.state.errMessage:null }</div>
             </div>
             </div>
           </div>
          </div>
          <div className="row">
            <div className="validate-blk-1 col-xs-12 col-sm-6  col-md-5 col-lg-3 col-md-offset-3 col-lg-offset-4 col-sm-offset-3">
              <div className="validate-button">
              <input type="submit" value="Submit" id="validate-button" onClick={ this.handleFormSubmit} />
              <div class="validate-cancel"> <button class="changebtnproperty" onClick={this.handleCancel}>Cancel</button></div>
              <div class="validate-new-code">Still haven’t received your code? <button class="changebtnproperty" onClick={this.redirectContact}>Get a new code.</button></div>
             </div>
           </div>
          </div>
        </React.Fragment>
    );
     }
   }
 }


 const mapStateToProps = (state) => {
  return {
    validateposts: state
  }
}

export default connect(mapStateToProps)(ValidateCode);
